import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './authform.component.css';
import { login } from '../../service/auth.service';

const AuthFormComponent = () => {

  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    mobile: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLogin) {
      // Handle login
      console.log('Login:', formData.email, formData.password);

      const dto = {
        username: formData.email,
        password: formData.password
      }

      try {
        const response = await login(dto);

        if (response && response.token) {
          // ✅ Store token
          localStorage.setItem('token', response.token);
          
          // ✅ Store user data if backend provides it
          if (response.user) {
            localStorage.setItem('userData', JSON.stringify(response.user));
            localStorage.setItem('loginId', response.user.loginId);
          } else {
            // ✅ Store minimal user data to prevent redirect loop
            const minimalUser = {
              email: formData.email,
              name: formData.email.split('@')[0], // temporary name from email
              loginId: response.loginId || null
            };
            localStorage.setItem('userData', JSON.stringify(minimalUser));
            if (response.loginId) {
              localStorage.setItem('loginId', response.loginId);
            }
          }
          
          // ✅ Small delay to ensure localStorage writes complete
          setTimeout(() => {
            navigate('/profile');
          }, 100);
        } else {
          alert("Authentication failed. Please check your credentials.");
        }
      } catch (error) {
        console.error('Login error:', error);
        alert("Login failed. Please try again.");
      }

    } else {
      // Handle signup
      if (formData.password !== formData.confirmPassword) {
        alert('Passwords do not match');
        return;
      }

      try {
        const signupPayload = {
          actionType: "INSERT",
          name: formData.name,
          email: formData.email,
          password: formData.password,
          phone: parseInt(formData.mobile, 10)  // ✅ Convert to Long and use "phone"
        };

        console.log('Signup payload:', { ...signupPayload, password: '***' });

        const response = await fetch("http://localhost:8082/api/seo-user", {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(signupPayload)
        });

        const data = await response.json().catch(() => null);
        console.log("Status:", response.status);
        console.log("Response body:", data);

        if (response.ok) {
          alert('Signup successful! Please login.');
          setIsLogin(true); // Switch to login tab
          // Clear form
          setFormData({
            email: '',
            password: '',
            confirmPassword: '',
            name: '',
            mobile: ''
          });
        } else {
          const errorMsg = data?.message || data?.title || 'Email may already be registered.';
          alert(`Signup failed: ${errorMsg}`);
        }
      } catch (error) {
        console.error('Signup error:', error);
        alert('Signup failed. Please try again.');
      }
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center auth-container cs-authdiv">
      {/* Background Logo */}
      <div className="background-logo">
        <div className="logo-text">eLexyt</div>
        <div className="logo-tagline">Where Technology Meets Tomorrow</div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-lg border-0 cs-radius">
              <div className="card-body p-5">
                {/* Logo/Brand */}
                <div className="text-center mb-4">
                  <img src="logo1.png" alt="ElexytSEO" width="80" height="60" className="mb-3" />
                  <h2 className="fw-bold text-dark mb-2">
                    {isLogin ? 'Welcome Back' : 'Get Started'}
                  </h2>
                  <p className="text-muted">
                    {isLogin ? 'Sign in to your account' : 'Create your account'}
                  </p>
                </div>

                {/* Toggle Buttons */}
                <div className="d-flex mb-4 cs-toggle">
                  <button
                    type="button"
                    className={`btn flex-fill cs-btn-radius ${isLogin ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => setIsLogin(true)}
                  >
                    Login
                  </button>
                  <button
                    type="button"
                    className={`btn flex-fill cs-btn-radius ${!isLogin ? 'btn-primary' : 'btn-light'}`}
                    onClick={() => setIsLogin(false)}
                  >
                    Sign Up
                  </button>
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit}>
                  {!isLogin && (
                    <>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">Full Name</label>
                        <input
                          type="text"
                          className="form-control cs-input"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required={!isLogin}
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="mobile" className="form-label">Mobile Number</label>
                        <input
                          type="tel"
                          className="form-control cs-input"
                          id="mobile"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleInputChange}
                          required={!isLogin}
                          pattern="[0-9]{10}"
                          placeholder="Enter 10-digit number"
                        />
                      </div>
                    </>
                  )}

                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control cs-input"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control cs-input"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {!isLogin && (
                    <div className="mb-4">
                      <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        className="form-control cs-input"
                        id="confirmPassword"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        required={!isLogin}
                      />
                    </div>
                  )}

                  {isLogin && (
                    <div className="mb-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" id="rememberMe" />
                          <label className="form-check-label" htmlFor="rememberMe">
                            Remember me
                          </label>
                        </div>
                        <Link to="/forgot-password" className="text-decoration-none">
                          Forgot password?
                        </Link>
                      </div>
                    </div>
                  )}

                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-3 mb-3 cs-loginbtn"
                  >
                    {isLogin ? 'Sign In' : 'Create Account'}
                  </button>
                </form>

                {/* Social Login */}
                <div className="text-center">
                  <p className="text-muted mb-3">Or continue with</p>
                  <div className="d-flex gap-3 justify-content-center">
                    <button className="btn btn-outline-secondary cs-icon">
                      <i className="fab fa-google"></i> Google
                    </button>
                    <button className="btn btn-outline-secondary cs-icon">
                      <i className="fab fa-linkedin"></i> LinkedIn
                    </button>
                  </div>
                </div>

                {/* Back to Home */}
                <div className="text-center mt-4">
                  <Link to="/" className="text-decoration-none">
                    <i className="fas fa-arrow-left me-2"></i>
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthFormComponent;